/**
 * Constantes del dominio de Notificaciones (campana de pedidos de láminas).
 *
 * Réplica de los parámetros de la campana del SSR (`templates/base.html`): el
 * intervalo de polling y la paleta por tipo de evento. Sin lógica de negocio ni
 * acceso a la API (`docs/frontend_architecture.md`, Pr. 6).
 */

/**
 * Permiso que habilita la campana. El SSR mostraba la campana a
 * mostrador/supervisor/admin; en la SPA se muestra a quien puede ver pedidos de
 * láminas, y el endpoint exige el MISMO permiso (`view_pedidos_laminas`). Coherente
 * con el resto del dominio de pedidos de láminas.
 */
export const NOTIFICATIONS_PERMISSION = "view_pedidos_laminas";

/**
 * Intervalo de sondeo en milisegundos, igual que el SSR (`POLL_MS = 12000` en
 * `base.html`): un compromiso entre frescura y carga. TanStack Query lo usa como
 * `refetchInterval`.
 */
export const NOTIFICATIONS_POLL_MS = 12_000;

/** Estilo (color de chip e icono) por tipo de evento. Réplica de `EVENTO_COLOR` del SSR. */
export interface EventStyle {
  /** Clases Tailwind para el chip (fondo + texto). */
  chip: string;
  /** Texto descriptivo del evento (para `aria-label`/tooltip). */
  label: string;
}

/**
 * Mapa evento -> estilo. Las claves coinciden con `evento` del backend
 * (`nuevo`/`enviado`/`recibido`); cualquier otro valor cae a `recibido` (ver
 * `eventStyle` en `format.ts`).
 */
export const EVENT_STYLES: Record<string, EventStyle> = {
  nuevo: { chip: "bg-blue-100 text-blue-700", label: "Nuevo pedido" },
  enviado: { chip: "bg-amber-100 text-amber-700", label: "Pedido en camino" },
  recibido: { chip: "bg-emerald-100 text-emerald-700", label: "Pedido recibido" },
};

/** Estilo por defecto cuando el evento no está en el mapa. */
export const DEFAULT_EVENT_STYLE: EventStyle = EVENT_STYLES.recibido;
